

exports.__esModule = true;

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _index = require('xo-models/src/checkout/index');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _util = require('pages/xo-login/util');

require('xo-page-components/src/value-props/directive');

require('xo-title/dist/directive');

require('xo-ui-components/src/message/directive');

require('xo-ui-components/src/error-tooltip/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoNbrDEPageDirective', {

    tag: 'xo-nbr-page',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        isUnbranded: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            var props = this.props;

            if (props.token) {
                return {
                    checkoutSession: _index.$CheckoutSessionModel.instance(props.token).retrieve({
                        contingencies: {
                            NEGATIVE_BALANCE_RECOVERY: _angular2['default'].noop,
                            EXPIRED_CREDIT_CARD: _angular2['default'].noop
                        }
                    }),
                    checkoutAppData: _index.$CheckoutAppDataModel.instance(props.token).retrieve()
                };
            }
        }
    },

    lifecycle: {
        enter: function enter() {
            var self = this,
                configUrls = _squid.$config.urls;

            (0, _jquery2['default'])('.paypalHeaderWrapper').hide();
            (0, _jquery2['default'])('.footerWrapper').addClass('nbr');

            // this is only used by DE
            self.nbrUrl = configUrls.nbrUrl;

            // only invoked via DE view
            self.meft = function (evt) {
                evt.preventDefault();
                // forward to negative legacy balance collection flow
                _squid.$util.redirect(configUrls.nbrUrl);
            };

            self.resume = function (evt) {
                var models = self.models;

                evt.preventDefault();

                // throw original contingency
                if (models.checkoutSession.origContName) {
                    throw new _squid.$Contingency(models.checkoutSession.origContName);
                }

                // consider CAPE scenario first
                if (models.checkoutAppData.is_second_button_txn) {
                    _util.$capeRedirectUtil.handleCapeRouting(models.checkoutSession, self.props.token);
                } else {
                    _uiRouter.$state.go('checkout.review');
                }
            };
        },
        exit: function exit() {
            (0, _jquery2['default'])('.paypalHeaderWrapper').show();
            (0, _jquery2['default'])('.footerWrapper').removeClass('nbr');
        },
        populate: function populate() {
            var self = this,
                checkoutSession = self.models.checkoutSession,
                negBals = checkoutSession.negBals,
                plan = checkoutSession.plan.sources && checkoutSession.plan.sources[0],
                tokenHash = {
                neg_bal: (0, _squid.formatCurrency)(negBals[0].amount, negBals[0].currency_code, false),
                amt: plan && (0, _squid.formatCurrency)(plan.amount, plan.currency_code, false)
            },
                bodyContentKey = 'nbr.body',
                preBankBtnKey = 'nbr.preBankBtn',
                prePayBtnKey = 'nbr.prePayBtn';

            if (negBals.length > 1) {
                bodyContentKey += 'Plural';
                preBankBtnKey += 'Plural';
                tokenHash.neg_bal2 = (0, _squid.formatCurrency)(negBals[1].amount, negBals[1].currency_code, false);
            }

            if (!plan) {
                prePayBtnKey += 'NoAmt';
            }

            self.bodyContentKey = bodyContentKey;
            self.tokenHash = tokenHash;
            self.isDE = _squid.$locale.metadata.country === 'DE';
            self.prePayBtnKey = prePayBtnKey;
            self.preBankBtnKey = preBankBtnKey;
        }
    }
});

_squid.formatCurrency;

_squid.$Component;

_squid.$locale;

_squid.$util;

_squid.$config;

_squid.$Contingency;

_uiRouter.$state;

_index.$CheckoutSessionModel;

_index.$CheckoutAppDataModel;

_util.$capeRedirectUtil;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-nbr/directive.js
// module id = ./pages/xo-nbr/directive.js
// module chunks = 1